export const works = [
  {
    id: "w1",
    title: "暗涌",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20moody%20crime%20thriller%2C%20silhouetted%20figure%20standing%20in%20a%20rain%20soaked%20neon%20alley%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20dramatic%20chiaroscuro%20lighting%2C%20atmospheric%20fog%2C%20subtle%20film%20grain%2C%20minimalist%20negative%20space%2C%20high%20detail%20editorial%20composition&width=600&height=800&seq=hp-work-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20rain%20drenched%20city%20street%20at%20night%20with%20deep%20red%20reflections%20on%20wet%20asphalt%2C%20moody%20atmospheric%20lighting%2C%20dark%20charcoal%20tones%2C%20soft%20mist%2C%20anamorphic%20bokeh%2C%20premium%20editorial%20cinematography&width=1600&height=700&seq=hp-workb-01&orientation=landscape",
    rating: 9.2,
    genre: ["悬疑", "犯罪"],
    year: 2024,
    region: "中国大陆",
    type: "电视剧",
    director: "陈牧",
    cast: ["秦墨", "苏晚", "林岩", "周静"],
    synopsis:
      "一桩尘封十五年的悬案因匿名举报信被重新翻开，刑警队长沈焱在追查真相的过程中，逐渐发现案件与自己的过往紧密相连。随着线索层层剥开，城市光鲜表面下暗涌的欲望与秘密逐一浮出水面。剧集以冷峻的镜头语言和缜密的叙事结构，探讨了正义、记忆与人性的灰色地带。",
    firstAir: "2024年3月18日",
    tags: ["年度高分", "罪案推理", "群像叙事"],
  },
  {
    id: "w2",
    title: "霓虹边缘",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20lone%20figure%20on%20a%20futuristic%20rooftop%20overlooking%20a%20crowded%20megacity%2C%20orange%20and%20crimson%20glow%2C%20dense%20architecture%2C%20soft%20haze%2C%20dramatic%20backlight%2C%20minimal%20composition%2C%20high%20detail%20cinematic%20key%20art&width=600&height=800&seq=hp-work-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20futuristic%20cityscape%20at%20dusk%20with%20warm%20orange%20and%20deep%20red%20lights%2C%20dense%20skyscrapers%2C%20soft%20atmospheric%20haze%2C%20symmetrical%20cinematic%20framing%2C%20premium%20sci%20fi%20film%20still%20aesthetic&width=1600&height=700&seq=hp-workb-02&orientation=landscape",
    rating: 8.7,
    genre: ["科幻", "悬疑"],
    year: 2023,
    region: "中国香港",
    type: "电影",
    director: "何家俊",
    cast: ["郑安华", "谢芷晴", "黄启铭"],
    synopsis:
      "在不远的未来，记忆可以被租借与买卖。一名记忆修复师接下一单看似普通的委托，却意外卷入一场关于身份与真相的阴谋。霓虹闪烁的都市边缘，每个人都可能在扮演别人的人生。影片以高概念设定包裹情感内核，视觉风格冷冽而华丽。",
    firstAir: "2023年11月2日",
    tags: ["高概念", "赛博质感", "影像美学"],
  },
  {
    id: "w3",
    title: "血色黄昏",
    cover: "https://readdy.ai/api/search-image?query=Epic%20action%20drama%20movie%20poster%20with%20a%20lone%20hero%20silhouette%20against%20a%20burning%20sunset%2C%20deep%20red%20and%20amber%20sky%2C%20dust%20and%20embers%20floating%2C%20dramatic%20cinematic%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail%20blockbuster%20key%20art&width=600&height=800&seq=hp-work-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20battlefield%20at%20sunset%20with%20warm%20amber%20and%20deep%20red%20sky%2C%20dust%20clouds%2C%20dramatic%20volumetric%20light%2C%20epic%20scale%2C%20premium%20film%20still%20aesthetic&width=1600&height=700&seq=hp-workb-03&orientation=landscape",
    rating: 8.3,
    genre: ["动作", "剧情"],
    year: 2025,
    region: "美国",
    type: "电影",
    director: "马库斯·里德",
    cast: ["伊桑·科尔", "莉娜·沃德"],
    synopsis:
      "退役特工为守护失散多年的家人重返危险世界，一场跨越三国的追逐将他的过去彻底点燃。影片以硬核动作场面与克制的情感表达著称，黄昏的色调贯穿始终，象征着一个时代的落幕与新生。",
    firstAir: "2025年1月24日",
    tags: ["硬核动作", "亲情内核", "视觉大片"],
  },
  {
    id: "w4",
    title: "城南旧梦",
    cover: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20romance%20movie%20poster%20of%20a%20young%20couple%20walking%20down%20an%20old%20Chinese%20town%20lane%2C%20soft%20golden%20afternoon%20light%2C%20deep%20red%20accents%2C%20gentle%20film%20grain%2C%20tender%20melancholic%20mood%2C%20minimal%20elegant%20composition&width=600&height=800&seq=hp-work-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20nostalgic%20old%20town%20alley%20at%20golden%20hour%20with%20warm%20afternoon%20sunlight%2C%20soft%20shadows%2C%20aged%20walls%2C%20tender%20cinematic%20film%20still%20aesthetic%20with%20gentle%20grain&width=1600&height=700&seq=hp-workb-04&orientation=landscape",
    rating: 8.9,
    genre: ["爱情", "文艺"],
    year: 2022,
    region: "中国大陆",
    type: "电影",
    director: "许知远",
    cast: ["沈知行", "叶南", "白鹭"],
    synopsis:
      "在一座正在拆迁的老城里，两个年轻人在最后一个夏天相遇。他们谈论诗歌、理想与离开，也在时代的缝隙中学会告别。影片用舒缓的节奏和细腻的镜头，将一段关于青春与故乡的记忆定格在旧梦之中。",
    firstAir: "2022年6月10日",
    tags: ["文艺佳作", "青春回忆", "细腻情感"],
  },
  {
    id: "w5",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20of%20a%20lone%20diver%20descending%20into%20a%20dark%20ocean%20trench%2C%20deep%20red%20and%20cold%20charcoal%20tones%2C%20eerie%20atmospheric%20lighting%2C%20submerged%20silence%2C%20high%20detail%20cinematic%20key%20art&width=600&height=800&seq=hp-work-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20underwater%20deep%20ocean%20scene%20with%20cold%20dark%20water%20and%20a%20single%20faint%20red%20light%20beam%2C%20mysterious%20atmosphere%2C%20cinematic%20film%20still%2C%20premium%20moody%20aesthetic&width=1600&height=700&seq=hp-workb-05&orientation=landscape",
    rating: 8.5,
    genre: ["惊悚", "悬疑"],
    year: 2024,
    region: "韩国",
    type: "电影",
    director: "朴承宇",
    cast: ["金泰旭", "李昭熙"],
    synopsis:
      "一支深海考察队在海底发现了一段不该存在的录音。随着声波被一次次解析，队员们开始怀疑彼此，也怀疑自己。影片以幽闭空间和声音设计营造出持续的心理压迫感，探讨人类对未知的恐惧。",
    firstAir: "2024年8月15日",
    tags: ["心理惊悚", "声音设计", "幽闭氛围"],
  },
  {
    id: "w6",
    title: "烈火如歌",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20of%20an%20elegant%20woman%20in%20flowing%20deep%20red%20robes%20holding%20a%20glowing%20lantern%2C%20ornate%20ancient%20architecture%20background%2C%20warm%20gold%20accents%2C%20romantic%20cinematic%20lighting%2C%20high%20detail%20costume%20design&width=600&height=800&seq=hp-work-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20warm%20lantern%20glow%2C%20deep%20red%20drapes%2C%20misty%20atmosphere%2C%20romantic%20period%20drama%20cinematic%20film%20still%2C%20elegant%20composition&width=1600&height=700&seq=hp-workb-06&orientation=landscape",
    rating: 8.1,
    genre: ["古装", "爱情"],
    year: 2023,
    region: "中国大陆",
    type: "电视剧",
    director: "顾清欢",
    cast: ["白青芜", "夜无棱", "苏离"],
    synopsis:
      "将门之女为查明家族蒙冤的真相，隐入深宫步步为营。她与冷面将军之间，由利用到交心，在权谋与情义之间反复拉扯。剧集以华丽的服化道和紧凑的权谋节奏，勾勒出一段烈火般炽热的传奇。",
    firstAir: "2023年9月1日",
    tags: ["古装权谋", "高颜值阵容", "虐恋情深"],
  },
  {
    id: "w7",
    title: "午夜列车",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20drama%20movie%20poster%20of%20a%20dimly%20lit%20night%20train%20carriage%2C%20a%20lone%20passenger%20by%20the%20window%2C%20deep%20red%20interior%20lights%2C%20rain%20streaked%20glass%2C%20moody%20cinematic%20shadows%2C%20high%20detail%20key%20art&width=600&height=800&seq=hp-work-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20night%20train%20exterior%20speeding%20through%20dark%20countryside%20with%20warm%20red%20window%20lights%2C%20rain%20and%20mist%2C%20moody%20cinematic%20atmosphere%2C%20premium%20film%20still&width=1600&height=700&seq=hp-workb-07&orientation=landscape",
    rating: 8.6,
    genre: ["悬疑", "剧情"],
    year: 2025,
    region: "日本",
    type: "电影",
    director: "中村凉太",
    cast: ["佐藤悠", "小林遥"],
    synopsis:
      "一列从未停靠的午夜列车，载着七个各怀秘密的乘客。当广播一次次念出不属于任何人的名字，他们必须在天亮前找出谁才是真正的旅人。影片以环形叙事和冷峻美学，编织出一场关于记忆与救赎的谜题。",
    firstAir: "2025年2月14日",
    tags: ["环形叙事", "冷峻美学", "烧脑谜题"],
  },
  {
    id: "w8",
    title: "追光者",
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20drama%20movie%20poster%20of%20a%20determined%20young%20athlete%20sprinting%20toward%20warm%20sunlight%2C%20dust%20and%20light%20rays%2C%20deep%20red%20and%20amber%20tones%2C%20dynamic%20cinematic%20motion%2C%20high%20detail%20motivational%20composition&width=600&height=800&seq=hp-work-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20running%20track%20at%20sunrise%20with%20warm%20amber%20light%20rays%20and%20long%20shadows%2C%20hopeful%20atmosphere%2C%20dynamic%20cinematic%20film%20still%2C%20premium%20inspiring%20aesthetic&width=1600&height=700&seq=hp-workb-08&orientation=landscape",
    rating: 8.4,
    genre: ["剧情", "励志"],
    year: 2024,
    region: "中国大陆",
    type: "电影",
    director: "程野",
    cast: ["陆星野", "夏知遥"],
    synopsis:
      "一名被伤病击倒的长跑运动员，在退役边缘遇到了同样不被看好的年轻教练。两个失意的人彼此成就，重新找回奔跑的意义。影片以真实细腻的训练日常和热血赛场，讲述普通人如何与命运赛跑。",
    firstAir: "2024年5月20日",
    tags: ["热血励志", "真实细腻", "治愈向上"],
  },
  {
    id: "w9",
    title: "罪案笔记",
    cover: "https://readdy.ai/api/search-image?query=Crime%20procedural%20poster%20of%20a%20detective%20studying%20a%20wall%20of%20evidence%20photos%20and%20red%20strings%2C%20dim%20office%20lighting%2C%20deep%20red%20accents%2C%20noir%20cinematic%20mood%2C%20high%20detail%20mystery%20key%20art&width=600&height=800&seq=hp-work-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20noir%20detective%20office%20at%20night%20with%20scattered%20files%20and%20warm%20red%20desk%20lamp%20glow%2C%20moody%20shadows%2C%20cinematic%20crime%20drama%20film%20still&width=1600&height=700&seq=hp-workb-09&orientation=landscape",
    rating: 8.8,
    genre: ["犯罪", "悬疑"],
    year: 2023,
    region: "美国",
    type: "电视剧",
    director: "丹尼尔·福斯特",
    cast: ["欧文·布莱克", "索菲娅·里德"],
    synopsis:
      "一位记忆超群却社交障碍的犯罪分析师，与经验丰富的老探员组成搭档，用逻辑和心理画像破解一桩桩悬案。剧集单集一案、主线暗藏，节奏紧凑，人物关系的成长贯穿全季。",
    firstAir: "2023年10月6日",
    tags: ["单元探案", "搭档成长", "逻辑缜密"],
  },
  {
    id: "w10",
    title: "山海秘境",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20poster%20of%20a%20young%20explorer%20standing%20before%20a%20mythical%20floating%20mountain%2C%20warm%20amber%20mist%2C%20deep%20red%20sky%2C%20ancient%20Chinese%20mythology%20mood%2C%20epic%20cinematic%20lighting%2C%20high%20detail%20key%20art&width=600&height=800&seq=hp-work-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20mythical%20floating%20mountains%20and%20misty%20valleys%20inspired%20by%20ancient%20Chinese%20mythology%2C%20warm%20amber%20and%20deep%20red%20sky%2C%20epic%20scale%2C%20cinematic%20fantasy%20film%20still&width=1600&height=700&seq=hp-workb-10&orientation=landscape",
    rating: 8.0,
    genre: ["奇幻", "冒险"],
    year: 2025,
    region: "中国大陆",
    type: "电影",
    director: "云澈",
    cast: ["江离", "阿芸", "墨阳"],
    synopsis:
      "传说山海之间藏着一处秘境，能实现最深的愿望。少年为救治病重的师父踏上寻秘之旅，一路结识伙伴、直面心魔。影片以瑰丽的东方奇幻世界观和流畅的冒险节奏，构建出一个令人神往的想象之地。",
    firstAir: "2025年7月12日",
    tags: ["东方奇幻", "冒险旅程", "视效惊艳"],
  },
  {
    id: "w11",
    title: "时光信笺",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20poster%20of%20hands%20holding%20an%20old%20letter%20with%20glowing%20warm%20light%2C%20floating%20dust%20particles%2C%20soft%20deep%20red%20and%20cream%20tones%2C%20tender%20nostalgic%20cinematic%20mood%2C%20high%20detail&width=600&height=800&seq=hp-work-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20warm%20sunlit%20study%20room%20with%20old%20letters%20and%20floating%20dust%20particles%2C%20soft%20cream%20and%20deep%20red%20tones%2C%20tender%20nostalgic%20cinematic%20film%20still&width=1600&height=700&seq=hp-workb-11&orientation=landscape",
    rating: 8.2,
    genre: ["爱情", "奇幻"],
    year: 2022,
    region: "中国台湾",
    type: "电影",
    director: "林知夏",
    cast: ["温以宁", "程亦舟"],
    synopsis:
      "女孩偶然发现一叠来自未来的信笺，每封信都预言了即将发生的事。她在试图改变结局的过程中，与写信人产生了跨越时空的羁绊。影片用轻奇幻的设定包裹一段温柔的爱情寓言。",
    firstAir: "2022年12月9日",
    tags: ["轻奇幻", "温柔治愈", "时空之恋"],
  },
  {
    id: "w12",
    title: "铁血防线",
    cover: "https://readdy.ai/api/search-image?query=Historical%20war%20drama%20poster%20of%20soldiers%20holding%20a%20defensive%20line%20at%20dawn%2C%20smoke%20and%20warm%20red%20light%2C%20solemn%20epic%20atmosphere%2C%20gritty%20cinematic%20texture%2C%20high%20detail%20composition&width=600&height=800&seq=hp-work-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20historical%20battle%20frontline%20at%20dawn%20with%20smoke%20and%20warm%20red%20firelight%2C%20solemn%20epic%20scale%2C%20gritty%20cinematic%20film%20still%20with%20authentic%20texture&width=1600&height=700&seq=hp-workb-12&orientation=landscape",
    rating: 8.5,
    genre: ["战争", "历史"],
    year: 2024,
    region: "英国",
    type: "电视剧",
    director: "爱德华·海斯",
    cast: ["托马斯·格雷", "艾米莉亚·克拉克"],
    synopsis:
      "二战背景下，一支普通士兵小队被派往一处看似平静的防线。随着时间推移，恐惧、友谊与人性的选择在战壕中被无限放大。剧集以克制的镜头和真实的历史细节，致敬那些沉默的守护者。",
    firstAir: "2024年4月5日",
    tags: ["历史正剧", "群像史诗", "克制动人"],
  },
];